import { Loading } from 'element-ui'

//loading参数配置
export const loadingConfig = {
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
}
let loading = null ;
//显示，可传入覆盖文案等配置：show({ text: '创建计划中...' })
const show = (options) => {
    const config = Object.assign({}, loadingConfig, options || {})
    loading = Loading.service(config);
}
//关闭
const close = (type) => {
    if (!loading) {
        return;
    }
    if (type === null){
        loading.close();
        loading = null;
        return;
    }
    const current = loading
    setTimeout(function () {
        if (current) {
            current.close();
        }
        if (loading === current) {
            loading = null;
        }
    },300)
    //loading.close();
}

export default {
    show(options){
        show(options);
    },
    close(type){
        close(type);
    }
}
